import React from 'react';
import type { FollowUpChipsBlock } from '../../types';

export interface FollowUpChipsBlockViewProps {
  block: FollowUpChipsBlock;
  onSelect?: (suggestion: string) => void;
}

export function FollowUpChipsBlockView({ block, onSelect }: FollowUpChipsBlockViewProps): React.ReactElement {
  return (
    <div data-testid="block-follow_up_chips" className="flex flex-wrap gap-2">
      {block.suggestions.map((suggestion, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onSelect?.(suggestion)}
          className="px-3 py-1 rounded-full border border-border-default bg-surface text-xs text-text-primary hover:bg-surface-secondary"
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
